// Set up your application entry point here...
import React from 'react';
import ReactDom from 'react-dom';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';

ReactDom.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,

  document.getElementById('app')
);
